import { render } from "./articleLeft.vue?vue&type=template&id=1d781822&scoped=true"
import script from "./articleLeft.vue?vue&type=script&lang=js"
export * from "./articleLeft.vue?vue&type=script&lang=js"

import "./articleLeft.vue?vue&type=style&index=0&id=1d781822&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d781822"]])

export default __exports__